export default __webpack_public_path__ + "static/software-development-fd2689b86be84f80acea358918d09549.png";